import React from "react"
import {
  compose,
  defaultProps,
  withHandlers,
  withStateHandlers,
} from "recompact"
import moment from "moment"
import { connect } from "react-redux"
import { P } from "@infotech/uikit-text"
import Chips from "@infotech/uikit-chips"
import storage from "src/helpers/storage"
import { Flex, Box, ContentCell } from "src/components/Grid"
import {
  selectPlanTagsAvailable,
  selectStatusAvailable,
} from "src/engine/modules/features/selectors"
import {
  PrimaryButton,
  SecondaryButton,
  FlatIconButton,
} from "@infotech/uikit-button"
import Filter from "src/icons/filter.svg"
import FilterFilled from "src/icons/filterFilled.svg"
import {
  SettingsIcon,
  AddIcon,
  LeftIcon,
  RightIcon,
  WarningOutlineIcon,
  TasksDownloadIcon,
  CompareIcon,
} from "@infotech/uikit-icons"
import TagsIcon from "src/icons/group.svg"
import cn from "classnames"
import ModalConfirm from "src/components/modals/ModalConfirm"
import TooltipWrapper from "src/components/Tooltips/TooltipWrapper"
import preventDefault from "src/helpers/preventDefault"
import {
  TODAY_START,
  TODAY_END,
  URL_DATE_FORMAT,
  DEFAULT_SCALE,
  SCALE_CODES,
  SCALE_ARROW_TOOLTIP,
  LAST_SELECTED_DATES,
  LAST_SCROLL_POSITIONS,
} from "src/containers/Calendar/constants"
import { selectValue } from "src/engine/modules/ui/selectors"
import { SIDEBAR_WIDTH, SIDEBAR_COMPACT_WIDTH } from "src/engine/modules/ui"
import { PLANS_URL } from "src/constants/routeNames"
import { creators } from "src/engine/modules/entity/actions"
import ValidateModal from "src/components/ValidateModal"
import { hasPermission } from "src/engine/modules/currentUser"
import {
  PLAN_LOCK,
  PLAN_UNLOCK,
  EVENTS_CHANGE_STATUS,
} from "src/constants/knownPermissions"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import noop from "lodash/noop"
import tooltip from "@infotech/uikit-tooltip"

import planModel from "src/models/plan"
import ResourceSearch from "./ResourceSearch"
import lockHelper from "./lockHelper"
import TemplatesMenu from "./TemplatesMenu"
import FilterModal from "./FilterModal"
import ValidateCounter from "./ValidateCounter"
import LockButton from "./LockButton"
import styles from "./styles.css"

moment.locale(`ru`)

const getAttribute = text => `calendar-header-${text}`

const TooltipSpan = tooltip.span()

function Item({ current, children }) {
  return (
    <ContentCell
      className={cn(styles[`today-wrapper`], {
        [styles.current]: current,
      })}
    >
      {children}
    </ContentCell>
  )
}

const validateTotalCount = validate => {
  const totalCount = []
  if (
    validate.eventViolations &&
    validate.resourceViolations &&
    validate.planViolations
  ) {
    validate.eventViolations.map(events =>
      totalCount.push(events.violations.length),
    )
    validate.resourceViolations.map(resources =>
      totalCount.push(resources.violations.length),
    )
    totalCount.push(validate.planViolations.violations.length)
    return totalCount.reduce((acc, val) => {
      return acc + val
    })
  }
  return false
}

const enhancer = compose(
  defaultProps({
    leftSidebarWidth: 100,
  }),
  withStateHandlers(
    {
      isConfirmationModalOpen: false,
      isTagsModalOpen: false,
      isPlanSettingsModalOpen: false,
      isPlanResourceEditorOpen: false,
      isValidateModalOpen: false,
      isFilterModalOpen: false,
    },
    {
      openConfirmationModal: () => () => ({
        isConfirmationModalOpen: true,
      }),
      closeConfirmationModal: () => () => ({
        isConfirmationModalOpen: false,
      }),
      toggleTagsModal: () => isTagsModalOpen => ({
        isTagsModalOpen: !isTagsModalOpen,
      }),
      toggleValidateModal: () => isValidateModalOpen => ({
        isValidateModalOpen: !isValidateModalOpen,
      }),
      toggleFilterModal: () => isFilterModalOpen => ({
        isFilterModalOpen: !isFilterModalOpen,
      }),
    },
  ),
  connect(
    state => ({
      isMenuVisible: selectValue(state, `isMenuVisible`),
      areMenuCaptionsVisible: selectValue(state, `areMenuCaptionsVisible`),
      canLock: hasPermission(PLAN_LOCK)(state),
      canUnlock: hasPermission(PLAN_UNLOCK)(state),
      canChangeStatus: hasPermission(EVENTS_CHANGE_STATUS)(state),
      selectPlanTagsAvailable: selectPlanTagsAvailable(state),
      isStatusAvailable: selectStatusAvailable(state),
    }),
    (dispatch, props) => {
      const data = get(props, `plan.data`)
      return {
        togglePlanLock: () =>
          dispatch(
            creators.update.success(planModel, get(data, `id`), {
              ...data,
              locked: !get(data, `locked`),
            }),
          ),
      }
    },
  ),
  withHandlers({
    toggleLock: ({ plan, togglePlanLock, closeConfirmationModal }) => () => {
      if (get(plan, `pending`)) {
        return
      }
      lockHelper({
        planUuids: get(plan, `data.uuid`),
        isLocked: get(plan, `data.locked`),
        toggle: togglePlanLock,
      })
      closeConfirmationModal()
    },
  }),
)

const getWith = (isMenuVisible, areMenuCaptionsVisible) => {
  if (isMenuVisible && areMenuCaptionsVisible) {
    return `calc(100vw - ${SIDEBAR_WIDTH + 1}px)`
  }
  if (isMenuVisible) {
    return `calc(100vw - ${SIDEBAR_COMPACT_WIDTH + 1}px)`
  }
  return `100vw`
}

export default enhancer(
  ({
    onAdd,
    onBack,
    onForward,
    isBackDisabled,
    isForwardDisabled,
    topContent,
    rightContent,
    centerContent,
    start,
    end,
    queryApi: { Link },
    history,
    match: {
      params: { date, scale },
    },
    location: { search },
    plan,
    toggleLock,
    isMenuVisible,
    areMenuCaptionsVisible,
    isConfirmationModalOpen,
    openConfirmationModal,
    closeConfirmationModal,
    isTagsModalOpen,
    isPlanSettingsModalOpen,
    toggleTagsModal,
    toggleValidateModal,
    isValidateModalOpen,
    toggleFilterModal,
    isFilterModalOpen,
    planResourceTypes,
    resourceTypes,
    requestValidate,
    planAllValidate,
    calendarPending,
    disableCreate,
    canLock,
    canUnlock,
    canChangeStatus,
    filterCalendarBy,
    resourceTypeIdFilter,
    resourceNameFilter,
    eventCustomFieldFilter,
    eventTypeIdFilter,
    statusCodeFilter,
    planId,
    eventTypes,
    selectPlanTagsAvailable,
    isStatusAvailable,
  }) => {
    const validationErrorsCount = validateTotalCount(planAllValidate)
    const isPlanLocked = get(plan, `data.locked`, false)
    const isTodayDisabled =
      get(plan, `data.startDateTime`, -Infinity) > moment().valueOf() ||
      get(plan, `data.endDateTime`, Infinity) < moment().valueOf()

    const getLockButtonState = () => {
      if (validationErrorsCount) {
        return {
          tooltip: `В плане есть ошибки, нельзя изменить статус`,
          disabled: true,
        }
      }

      if (isPlanLocked && !canUnlock) {
        return {
          tooltip: `У вас нет полномочия на разблокировку планов.`,
          disabled: true,
        }
      }

      if (!isPlanLocked && !canLock) {
        return {
          tooltip: `У вас нет полномочия на блокировку планов.`,
          disabled: true,
        }
      }

      return {
        tooltip: null,
        disabled: false,
      }
    }
    const lockButtonState = getLockButtonState()
    const lockIconTooltip = isPlanLocked ? `Разблокировать` : `Заблокировать`

    const openMassTransfer = () =>
      history.push(
        `/plans/${planId}/calendar/${scale}/${date}/planEvents${search}`,
      )

    return (
      <div className={styles[`standard-height`]}>
        <Flex
          className={styles.Header}
          style={{
            width: getWith(isMenuVisible, areMenuCaptionsVisible),
          }}
        >
          <div className={styles.HeaderSubWrapper}>
            {topContent}
            <Flex className={styles.CalendarNavControlWrapper}>
              <Flex className={styles.LeftTopBar}>
                <Box flex align="center">
                  {onAdd && (
                    <ContentCell className={styles[`button-add-wrapper`]}>
                      {plan && isPlanLocked ? (
                        <TooltipWrapper
                          className={styles.Tooltip}
                          tooltipLabel="Чтобы добавить событие, сначала разблокируйте план"
                          tooltipPosition="right"
                          tooltipFixed
                        >
                          <div data-testid="calendar-create-event-button">
                            <PrimaryButton
                              className={styles[`button-add`]}
                              disabled
                            >
                              <AddIcon size="small" color="white" />
                            </PrimaryButton>
                          </div>
                        </TooltipWrapper>
                      ) : (
                        <PrimaryButton
                          className={styles[`button-add`]}
                          onClick={onAdd}
                          disabled={disableCreate}
                        >
                          <AddIcon size="small" color="white" />
                        </PrimaryButton>
                      )}
                    </ContentCell>
                  )}
                  {plan && (
                    <>
                      <Box flex loose>
                        <Box mr="-3md" ml="-2md" pt="2md">
                          <div className={styles[`tail-right-border`]} />
                        </Box>

                        {canChangeStatus && isStatusAvailable && (
                          <Box loose pt="2md" pr="2md">
                            {isPlanLocked ? (
                              <TooltipSpan
                                tooltip="Для массового перевода статуса, сначала разблокируйте план"
                                tooltipConfig={{
                                  placement: `bottom`,
                                }}
                              >
                                <span className={styles.icon}>
                                  <CompareIcon
                                    size="medium"
                                    className={styles.icon}
                                  />
                                </span>
                              </TooltipSpan>
                            ) : (
                              <TooltipSpan
                                tooltip="Массовый перевод статусов"
                                tooltipConfig={{
                                  placement: `bottom`,
                                }}
                              >
                                <div data-testid={getAttribute(`massive-icon`)}>
                                  <span
                                    className={styles.icon}
                                    onClick={openMassTransfer}
                                  >
                                    <CompareIcon
                                      size="medium"
                                      className={styles.icon}
                                    />
                                  </span>
                                </div>
                              </TooltipSpan>
                            )}
                          </Box>
                        )}
                      </Box>
                      <Box flex loose>
                        <Box loose pt="10px" pr="2md">
                          {isPlanLocked ? (
                            <TooltipSpan
                              tooltip="Для выгрузки отчетов, сначала разблокируйте план"
                              tooltipConfig={{
                                placement: `bottom`,
                              }}
                            >
                              <span className={styles.icon}>
                                <TasksDownloadIcon size="medium" />
                              </span>
                            </TooltipSpan>
                          ) : (
                            <span className={styles.icon}>
                              <div data-testid={getAttribute(`template-icon`)}>
                                <TemplatesMenu
                                  planId={get(plan, `id`)}
                                  planTypeId={get(plan, `data.planTypeId`)}
                                />
                              </div>
                            </span>
                          )}
                        </Box>
                      </Box>
                    </>
                  )}
                  <Box flex loose>
                    <Box mr="-3md" ml="-2md" pt="2md">
                      <div className={styles[`tail-right-border`]} />
                    </Box>
                    <Box loose pt="12px" pr="2md">
                      <ResourceSearch
                        filterCalendarBy={filterCalendarBy}
                        resourceNameFilter={resourceNameFilter}
                        getAttribute={getAttribute}
                      />
                    </Box>
                  </Box>
                </Box>
              </Flex>
              <Item
                current={
                  start.valueOf() === TODAY_START && end.valueOf() === TODAY_END
                }
              >
                {isTodayDisabled ? (
                  <TooltipSpan
                    className={cn(styles.today, styles.todayDisabled)}
                    tooltip="Сегодняшняя дата не входит в границы плана"
                    tooltipConfig={{
                      placement: `bottom`,
                    }}
                  >
                    <SecondaryButton disabled>Сегодня</SecondaryButton>
                  </TooltipSpan>
                ) : (
                  <Link
                    to={window.location.pathname.replace(
                      /\/calendar\/?[^/]*\/?[^/]*/,
                      `/calendar/${SCALE_CODES[DEFAULT_SCALE]}/${moment(
                        TODAY_START,
                      )
                        .startOf(SCALE_CODES[DEFAULT_SCALE])
                        .format(URL_DATE_FORMAT)}`,
                    )}
                    onClick={() => {
                      storage.remove(LAST_SELECTED_DATES)
                      storage.remove(LAST_SCROLL_POSITIONS)
                    }}
                  >
                    <div data-testid={getAttribute(`today-button`)}>
                      <SecondaryButton>Сегодня</SecondaryButton>
                    </div>
                  </Link>
                )}
              </Item>
              <Box loose pt="2md" pr="2md">
                <div className={styles[`tail-right-border`]} />
              </Box>
              <ContentCell className={styles[`center-content-wrapper`]}>
                <div className={styles.Date} data-testid={getAttribute(`date`)}>
                  <Flex align="center">
                    <Flex align="center">{centerContent}</Flex>
                  </Flex>
                </div>
              </ContentCell>
              <Flex>
                <ContentCell
                  className={cn(styles[`back-icon-wrapper`], styles.icon)}
                >
                  <Box loose ml="-2md" pr="2md">
                    <div className={styles[`tail-right-border`]} />
                  </Box>
                  <TooltipSpan
                    tooltip={SCALE_ARROW_TOOLTIP[scale || `month`].back}
                    tooltipConfig={{
                      placement: `bottom`,
                    }}
                  >
                    <div data-testid={getAttribute(`back-scale`)}>
                      <FlatIconButton
                        onClick={preventDefault(isBackDisabled ? noop : onBack)}
                        icon={LeftIcon}
                        iconSize="big"
                      />
                    </div>
                  </TooltipSpan>
                </ContentCell>
                <ContentCell
                  className={cn(styles[`forward-icon-wrapper`], styles.icon)}
                >
                  <TooltipSpan
                    tooltip={SCALE_ARROW_TOOLTIP[scale || `month`].forward}
                    tooltipConfig={{
                      placement: `bottom`,
                    }}
                  >
                    <div data-testid={getAttribute(`forward-scale`)}>
                      <FlatIconButton
                        onClick={preventDefault(
                          isForwardDisabled ? noop : onForward,
                        )}
                        icon={RightIcon}
                        iconSize="big"
                      />
                    </div>
                  </TooltipSpan>
                  <Box loose>
                    <div className={styles[`tail-right-border`]} />
                  </Box>
                </ContentCell>
              </Flex>
              <ContentCell className={styles.RightTopBar}>
                {rightContent}
                <div
                  className={cn(
                    styles[`tail-right-border`],
                    styles[`no-margin`],
                  )}
                />
              </ContentCell>
              {plan && (
                <Flex row pt="2md">
                  {selectPlanTagsAvailable && (
                    <Box className={styles.IconCellWrapper}>
                      {plan.data && plan.data.tags.length ? (
                        <div
                          data-testid={getAttribute(`tags-icon`)}
                          style={{ display: `flex` }}
                          onClick={() => toggleTagsModal(isTagsModalOpen)}
                        >
                          <TooltipSpan
                            className={cn(styles.today, styles.todayDisabled)}
                            tooltip="Теги"
                            tooltipConfig={{
                              placement: `bottom`,
                            }}
                          >
                            <TagsIcon
                              size="medium"
                              className={cn(styles[`tags-icon`], styles.icon)}
                              color={isTagsModalOpen ? `#000` : `#aaa`}
                            />
                          </TooltipSpan>
                        </div>
                      ) : (
                        <TooltipSpan
                          className={cn(styles.today, styles.todayDisabled)}
                          tooltip="Теги отсутствуют"
                          tooltipConfig={{
                            placement: `bottom`,
                          }}
                        >
                          <TagsIcon
                            size="medium"
                            className={styles[`tags-icon`]}
                            color="#aaa"
                          />
                        </TooltipSpan>
                      )}
                    </Box>
                  )}
                  <Box
                    className={styles.IconCellWrapper}
                    pl="2md"
                    ml={validationErrorsCount ? `-16px` : 0}
                    pr={validationErrorsCount ? `16px` : 0}
                  >
                    {plan && (
                      <TooltipSpan
                        className={cn(styles.today, styles.todayDisabled)}
                        tooltip={lockButtonState.tooltip || lockIconTooltip}
                        tooltipConfig={{
                          placement: `bottom`,
                        }}
                      >
                        <div data-testid={getAttribute(`lock-plan-icon`)}>
                          <LockButton
                            onClick={openConfirmationModal}
                            isLocked={isPlanLocked}
                            disabled={lockButtonState.disabled}
                          />
                        </div>
                      </TooltipSpan>
                    )}
                  </Box>
                  <Box className={styles.IconCellWrapper} pl="2md">
                    {plan && plan.id && (
                      <TooltipSpan
                        className={cn(styles.today, styles.todayDisabled)}
                        tooltip="Ошибки и предупреждения плана"
                        tooltipConfig={{
                          placement: `bottom`,
                        }}
                      >
                        <div data-testid={getAttribute(`warning-icon`)}>
                          <span
                            onClick={() => toggleValidateModal()}
                            className={styles.icon}
                          >
                            <WarningOutlineIcon
                              color={isPlanSettingsModalOpen ? `#000` : `#aaa`}
                            />
                            {Boolean(validationErrorsCount) &&
                              !calendarPending && (
                                <ValidateCounter
                                  validate={planAllValidate}
                                  totalCount={validationErrorsCount}
                                />
                              )}
                          </span>
                        </div>
                      </TooltipSpan>
                    )}
                  </Box>
                  <Box className={styles.IconCellWrapper}>
                    <div data-testid={getAttribute(`setting-plan-icon`)}>
                      <span
                        onClick={() =>
                          history.push(
                            `${PLANS_URL}/${plan.id}/calendar/${scale}/${date}/settings/main${search}`,
                          )
                        }
                        className={cn(
                          styles.icon,
                          styles[`plan-settings-icon`],
                        )}
                      >
                        <SettingsIcon
                          color={isPlanSettingsModalOpen ? `#000` : `#aaa`}
                        />
                      </span>
                    </div>
                  </Box>
                </Flex>
              )}
              <Flex>
                <Box>
                  <Box pl="12px" pt="2md">
                    {!isEmpty(
                      resourceTypeIdFilter.concat(
                        eventTypeIdFilter,
                        statusCodeFilter,
                        eventCustomFieldFilter || [],
                      ),
                    ) ? (
                      <Box
                        data-testid={getAttribute(`filter-active-icon`)}
                        loose
                        onClick={() => toggleFilterModal()}
                      >
                        <FilterFilled
                          className={styles.FilledFilterIcon}
                          size="medium"
                          color="#2880ff"
                        />
                      </Box>
                    ) : (
                      <Box
                        data-testid={getAttribute(`filter-inactive-icon`)}
                        loose
                        onClick={() => toggleFilterModal()}
                      >
                        <Filter className={styles.icon} />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Flex>
            </Flex>
          </div>
        </Flex>
        {plan && (
          <div>
            <ModalConfirm
              isOpen={isConfirmationModalOpen}
              title={
                isPlanLocked ? `Разблокировать план?` : `Заблокировать план?`
              }
              buttonConf={[
                {
                  text: isPlanLocked ? `Разблокировать` : `Заблокировать`,
                  onClick: toggleLock,
                  isOk: true,
                  done: !!plan,
                  disabled: false,
                },
                {
                  text: `Отмена`,
                  onClick: closeConfirmationModal,
                  disabled: false,
                },
              ]}
              isLock={!isPlanLocked}
              isUnlock={isPlanLocked}
              pending={get(plan, `pending`)}
            >
              <div>
                <P className={styles[`modal-message-text`]}>
                  {isPlanLocked
                    ? `После разблокировки плана будут доступны все действия с планом и событиями`
                    : `После блокировки плана вы сможете работать с ним только в режиме просмотра`}
                </P>
              </div>
            </ModalConfirm>
            {isTagsModalOpen && (
              <div>
                <div className={styles[`tags-modal`]}>
                  <Chips options={plan.data.tags} max={0} />
                </div>
                <div
                  className={styles[`tags-modal-overlay`]}
                  onClick={() => toggleTagsModal(isTagsModalOpen)}
                />
              </div>
            )}
          </div>
        )}
        {plan && isValidateModalOpen && (
          <ValidateModal
            data={planAllValidate}
            history={history}
            closeModal={toggleValidateModal}
            refreshValidate={() => requestValidate({ plan: plan.id })}
            resourceRedirectPath={`${PLANS_URL}/${planId}/calendar/${scale}/${date}/settings/resources${search ||
              ``}`}
          />
        )}
        {isFilterModalOpen && (
          <FilterModal
            closeModal={() => toggleFilterModal(isFilterModalOpen)}
            isFilterModalOpen={isFilterModalOpen}
            planResourceTypes={planResourceTypes}
            resourceTypes={resourceTypes || {}}
            filterCalendarBy={filterCalendarBy}
            eventTypes={eventTypes}
            resourceTypeIdFilter={resourceTypeIdFilter}
            eventCustomFieldFilter={eventCustomFieldFilter}
            eventTypeIdFilter={eventTypeIdFilter}
            statusCodeFilter={statusCodeFilter}
            planId={planId}
            isStatusAvailable={isStatusAvailable}
          />
        )}
      </div>
    )
  },
)
